module.exports = __webpack_public_path__ + "static/img/goodness2.9304958e.png";